import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type React from 'react';
import type { FC } from 'react';

interface Props {
  children: React.ReactNode;
  title?: string;
  actionBtn?: React.ReactNode | null;
  sx?: object;
  fullWidth?: boolean;
  fullHeight?: boolean;
}

const PaperContainer: FC<Props> = ({
  children,
  title = '',
  actionBtn = null,
  fullWidth = false,
  fullHeight = false,
  sx = {},
}) => {
  return (
    <Paper
      sx={{
        width: fullWidth ? '100%' : { xs: '100%', md: '80%', lg: '60%' },
        height: fullHeight ? '100%' : 'auto',
        minHeight: '150px',
        borderRadius: '20px',
        py: 3,
        px: { xs: 2, lg: 4 },
        my: 2,
        overflowX: 'auto',
        ...sx,
      }}
    >
      {title || actionBtn ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              mb: { xs: 2, lg: 0 },
              textAlign: 'left',
            }}
          >
            {title}
          </Typography>
          {actionBtn && (
            <Box
              sx={{
                mx: 1,
              }}
            >
              {actionBtn}
            </Box>
          )}
        </Box>
      ) : null}
      {children}
    </Paper>
  );
};

export default PaperContainer;
